﻿import { Splide } from './../vendor/splidejs/js/splide.esm.js';

export  class ArticleSlider {
  	constructor() {
		this.silderElements = document.querySelectorAll('[data-tile-slider]');
		this.init();
	}

    init() {
      	if (!this.silderElements.length) return

      	this.silderElements.forEach((sliderElement) => {
			const slider = new Splide( sliderElement, {
				perPage: 4,
				perMove: 1,
				gap: '16px',
				pagination: true,
				classes: {
					// Add classes for arrows.
					arrow : 'splide__arrow tile-slider__arrow',
					prev  : 'splide__arrow--prev tile-slider__arrow--prev',
					next  : 'splide__arrow--next tile-slider__arrow--next',
				},
				breakpoints: {
					992: {
						perPage: 3,
						arrows: false,
					},
					768: {
						perPage: 2,
					},
					640: {
					},
					576: {
						perPage: 1,
						padding: '1px'
					},
				},
				arrows: true,
			})
			slider.mount()
      	});
    }
}